import { createSlice } from '@reduxjs/toolkit';
import { TableState } from '../../components/table/model';

const initialState: TableState = {
  columns: [],
};

const profilemapListSlice = createSlice({
  name: 'profilemapTable',
  initialState,
  reducers: {
    hideColumn(state) {},
  },
});

export const profilemapsReducer = profilemapListSlice.reducer;
